import React from "react"
import PropTypes from "prop-types"
import Card from "../layout/card"
import Row from "../layout/Row/Row"
import Stack from "../layout/Stack/Stack"
import { InlineText, SubTitle, Title } from "../Typography/Typography"

import { item, statsOverviewPanel } from "./styles.module.scss"

const Tile = ({ title, value }) => (
  <Stack className={item}>
    <SubTitle small>{title}</SubTitle>
    <InlineText bold large>
      {value}
    </InlineText>
  </Stack>
)

Tile.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
}

const regulator = {
  ci: "Care Inspectorate",
  cqc: "Care Quality Commission",
}

const makeTileData = ({
  location,
  careHomeCount,
  nursingCareHomeCount,
  dementiaCareHomeCount,
  careHomesRatedPositiveCount,
  regulatoryBody,
}) => [
  { title: `Care homes in ${location}`, value: careHomeCount },
  { title: "Homes that offer nursing care", value: nursingCareHomeCount },
  { title: "Specialise in dementia care", value: dementiaCareHomeCount },
  { title: "Homes rated good or above", value: careHomesRatedPositiveCount },
  { title: `${location}'s Care Regulator`, value: regulator[regulatoryBody] },
]

export default function StatsOverviewPanel({
  location,
  careHomeCount,
  nursingCareHomeCount,
  dementiaCareHomeCount,
  careHomesRatedPositiveCount,
  regulatoryBody,
}) {
  return (
    <Card extraClasses={statsOverviewPanel}>
      <Title>Overview of care homes in {location}</Title>
      <Row wrap>
        {makeTileData({
          location,
          careHomeCount,
          nursingCareHomeCount,
          dementiaCareHomeCount,
          careHomesRatedPositiveCount,
          regulatoryBody,
        }).map(({ title, value }) => (
          <Tile key={title} title={title} value={value} />
        ))}
      </Row>
    </Card>
  )
}

StatsOverviewPanel.propTypes = {
  location: PropTypes.string.isRequired,
  regulatoryBody: PropTypes.oneOf(["ci", "cqc"]).isRequired,
  careHomeCount: PropTypes.number,
  nursingCareHomeCount: PropTypes.number,
  dementiaCareHomeCount: PropTypes.number,
  careHomesRatedPositiveCount: PropTypes.number,
}

StatsOverviewPanel.defaultProps = {
  careHomeCount: 0,
  nursingCareHomeCount: 0,
  dementiaCareHomeCount: 0,
  careHomesRatedPositiveCount: 0,
}
